import mod from "-!./recoverPassword.js?vue&type=script&lang=js&"; export default mod; export * from "-!./recoverPassword.js?vue&type=script&lang=js&"